<template>
  <v-app>
    <div
      class="water-marking"
      :style="markingBackgroundImage"
    ></div>
    <Notification></Notification>
    <router-view v-slot="{ Component }">
      <FadeSlideTransition>
        <component :is="Component" />
      </FadeSlideTransition>
    </router-view>
  </v-app>
</template>

<script>
import FadeSlideTransition from '@/components/FadeSlideTransition.vue'
import iStoreSetting from '@/scripts/istore-setting'
import iStoreApi from '@/scripts/istore-api'
import Notification from '@/views/Notification.vue';
import imanager3Appframe from "@/scripts/imanager3-appframe";

export default {
  components: {FadeSlideTransition, Notification},
  data() {
    return {
      watermarkSize: null
    }
  },
  created() {
    if (iStoreSetting.debug) {
      window._APP = this
      window._iStoreApi = iStoreApi
      window._Setting = iStoreSetting

      this.$store.subscribe((mutation) => {

        if (mutation.type !== "resetActivityTimeout") {
          console.debug('%c[%s]%c#[STORE] Mutation:[%s]', 'color:#CCCCCC', new Date().toLocaleTimeString(), 'color:#BD00B9', mutation.type)
        }
      }, {prepend: true})
    }
  },
  beforeMount() {
    window.addEventListener('message', this.onMessage)
    window.addEventListener('mousemove', this.resetActivityTimeout)
  },
  beforeUnmount() {
    window.removeEventListener('mousemove', this.resetActivityTimeout)
    window.removeEventListener('message', this.onMessage)
  },
  methods: {
    onMessage(evt) {
      imanager3Appframe.onMessage(evt, "app")
    },
    async getWatermarkSetting() {
      const getWatermarkSettingResult = await iStoreApi.searchKeyPrefix("globalSetting", "globalSetting.imanager.config.default")
      if (getWatermarkSettingResult.length !== 0) {
        this.$store.commit('setGlobalSetting', getWatermarkSettingResult[0].value)
        this.$store.dispatch('initializeWatermark', this.$store.state.globalSettingData.watermarkFileUrl)
      } else {
        this.$store.commit('setGlobalSetting', {
          watermarkName: null,
          watermarkFileUrl: ""
        })
      }
    },
  },
  computed: {
    markingBackgroundImage() {
      const img = this.$store.state.watermarkSetting.backgroundImage
      if (!this.watermarkSize) return { backgroundImage: img } // fallback while loading
      if (!img) return { backgroundImage: "none" }

      let { w, h } = this.watermarkSize

      // Reduce tile size to 80% (or any ratio < 100%)
      const scale = 0.8
      const tileW = w * scale
      const tileH = h * scale

      return {
        backgroundImage: `${img}, ${img}`,
        backgroundSize: `${tileW}px ${tileH}px, ${tileW}px ${tileH}px`,
        backgroundRepeat: "repeat, repeat",
        backgroundPosition: `0 0, ${tileW / 2}px ${tileH / 2}px`
      }
    }
  },
  watch: {
    "$store.state.watermarkSetting.backgroundImage": {
      immediate: true,
      handler(newImg) {
        if (!newImg) return
        const image = new Image()
        // strip `url("...")` wrapper if present
        image.src = newImg.replace(/^url\(["']?/, "").replace(/["']?\)$/, "")
        image.onload = () => {
          this.watermarkSize = { w: image.width, h: image.height }
        }
      }
    }
  }
}
</script>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
